const CHAT_FALLBACK_PATH = "/admin/chat";
const NOTIFICATION_GAP_MS = 1200;

let nextNotificationAt = 0;

function getBrowserWindow() {
  if (typeof window === "undefined") return null;
  return window;
}

function isNotificationApiAvailable() {
  return typeof Notification !== "undefined";
}

function isSecureBrowserContext() {
  const browserWindow = getBrowserWindow();
  if (!browserWindow) return false;
  return Boolean(browserWindow.isSecureContext);
}

function buildChatPath(contactId) {
  if (!contactId) return CHAT_FALLBACK_PATH;
  return `/admin/chat/${contactId}`;
}

function buildAbsoluteUrl(path) {
  const browserWindow = getBrowserWindow();
  if (!browserWindow) return path;
  return new URL(path, browserWindow.location.origin).toString();
}

function getNotificationIcon() {
  const browserWindow = getBrowserWindow();
  if (!browserWindow) return undefined;
  return new URL("/favicon.png", browserWindow.location.origin).toString();
}

export function canUseDesktopNotifications() {
  return (
    Boolean(getBrowserWindow()) &&
    isNotificationApiAvailable() &&
    isSecureBrowserContext()
  );
}

export function getDesktopNotificationPermission() {
  if (!isNotificationApiAvailable()) return "unsupported";
  if (!isSecureBrowserContext()) return "insecure";
  return Notification.permission;
}

export async function requestDesktopNotificationPermission() {
  const permission = getDesktopNotificationPermission();

  if (permission === "unsupported" || permission === "insecure") {
    return permission;
  }

  if (permission !== "default") return permission;

  try {
    return await Notification.requestPermission();
  } catch (error) {
    return "denied";
  }
}

export function showIncomingDesktopNotification({
//   agentName,
  contactName,
  contactPhone,
  contactId,
  messageId,
  body,
}) {
  if (!canUseDesktopNotifications()) return null;
  if (getDesktopNotificationPermission() !== "granted") return null;

// console.log('telefono', contactPhone);

  const userName =
    contactName || (contactPhone ? contactPhone.toString() : "Contacto");
  const safeContactName =
    contactName && contactName !== "Un contacto"
      ? contactName
      : contactPhone || "Contacto";

  const targetPath = buildChatPath(contactId);
  const targetUrl = buildAbsoluteUrl(targetPath);

  const showNotification = () => {
    try {
      return new Notification(`${userName} - Nuevo mensaje`, {
        body: body || `${safeContactName} te ha enviado un mensaje.`,
        icon: getNotificationIcon(),
        tag: `message-${String(messageId || `${Date.now()}-${Math.random()}`)}`,
        timestamp: Date.now(),
        data: {
          targetUrl,
          contactId,
        },
      });
    } catch {
      return null;
    }
  };

  const now = Date.now();
  const delay = Math.max(0, nextNotificationAt - now);
  nextNotificationAt = Math.max(now, nextNotificationAt) + NOTIFICATION_GAP_MS;

  if (delay > 0) {
    setTimeout(() => {
      const delayedNotification = showNotification();
      if (!delayedNotification) return;
      delayedNotification.onclick = () => {
        const browserWindow = getBrowserWindow();
        if (!browserWindow) return;

        const nextUrl = delayedNotification?.data?.targetUrl || targetUrl;

        browserWindow.focus();
        if (browserWindow.location.href !== nextUrl) {
          browserWindow.location.assign(nextUrl);
        }
        delayedNotification.close();
      };
    }, delay);

    return null;
  }

  const notification = showNotification();
  if (!notification) return null;

  notification.onclick = () => {
    const browserWindow = getBrowserWindow();
    if (!browserWindow) return;

    const nextUrl = notification?.data?.targetUrl || targetUrl;

    browserWindow.focus();
    if (browserWindow.location.href !== nextUrl) {
      browserWindow.location.assign(nextUrl);
    }
    notification.close();
  };

  return notification;
}
